module.exports = __webpack_public_path__ + "static/media/a-5-b.3181f93c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-5-b.jpg
// module id = 1104
// module chunks = 33